import React from 'react';
import { Button, useMediaQuery, Box } from '@material-ui/core';
import dashboardStyles from './feedback.style';
import { FEEDBACK_BTN_TXT, RB_FEEDBACK_URL } from 'constants/constant';
import feedback from 'assets/svgs/feedback.svg';

function Feedback() {
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const classes = dashboardStyles({ isSmallScreen });
	return (
		<Box className={classes.feedbackBtn}>
			<Button
				className={classes.feedbackTxt}
				onClick={() => {
					window.open(`${RB_FEEDBACK_URL}`, '_blank', 'noreferrer');
				}}>
				{FEEDBACK_BTN_TXT}
			</Button>
			<img src={feedback} className={classes.feedbackIcon} alt="share-icon"></img>
		</Box>
	);
}

export default Feedback;
